import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransactionStatus } from 'src/app/interfaces/payment-option';
import { GetPostbackFormDataResponse } from 'src/app/interfaces/PostbackFormData/GetPostbackFormDataResponse';
import { Session } from 'src/app/interfaces/session-data';
import { PaymentService } from 'src/app/services/payment/payment.service';

@Component({
  selector: 'app-transation-status-version-two',
  templateUrl: './transation-status.component.html',
  styleUrls: ['./transation-status.component.scss']
})
export class TransationStatusComponent implements OnInit {

  loading = true;
  @ViewChild('form') form: HTMLFormElement;

  session: Session;
  transactionStatus: TransactionStatus;
  postbackData: GetPostbackFormDataResponse;
  headerColor;
  date = new Date().toJSON();
  result:boolean;
  cardType;
  paymentMethodImg;
  paymentMethod;
  transactionFraud;
  persistElChangesInterval;
  count;
  userCancelled;
  errorMessage;
  errorDescription = 'Redirecting you back to the merchant...';
  mobile;
  loadingRedirect = true;
  postBackFailed = false;
  hidePgLogo = false;
  sessionData: Session;

  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService
  ) {
    this.paymentMethod = sessionStorage.getItem('selected-payment');
    this.cardType = sessionStorage.getItem('card_type');
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));
  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = true; // this.sessionData.sessionDisplayInformation.hidePgLogo === 'true';
    this.route.queryParams.subscribe((data) => {
      this.getPostbackData();
    }, () => {
      console.log('Error fetching postback data');
      this.getPostbackData();
    });

    if (window.location.search.indexOf('fraud') > -1) {
      this.transactionFraud = true;
    }
  }

  submitForm(form: HTMLFormElement) {
    form.submit();
  }

  setTimeoutForHtmlFormAndSubmit(postBackData: GetPostbackFormDataResponse) {
    if (postBackData && postBackData.url) {
      setTimeout(() => {
        if (postBackData.isShopifyTransaction) {
          console.log('Shopify transaction, redirecting instead of posting form');
          // Check if we're in an iframe and try to break out if needed
          if (this.isInIframe()) {
            try {
              // Try to navigate the top window
              window.top.location.href = postBackData.url;
            } catch (e) {
              // If security restrictions prevent this, fall back to current window
              console.log('Could not navigate top window due to security restrictions:', e);
              window.location.href = postBackData.url;
            }
          } else {
            // Not in iframe, normal navigation
            window.location.href = postBackData.url;
          }
        } else {
          console.log('Post back to merchant');
          if (!document.getElementById('form')) {
            setInterval(() => {
              if (document.getElementById('form')) {
                (document.getElementById('form') as HTMLFormElement).submit();
                // this.loadingRedirect = false;
              }
            }, 2000);
          } else {
            (document.getElementById('form') as HTMLFormElement).submit();
          }
        }
        // this.loadingRedirect = false;
      }, 2000);
    }
  }

  postBackResultSuccessful(result: string) {
    return parseInt(result, 10) > -1;
  }
  private isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we can't access window.top due to security restrictions,
      // we're definitely in an iframe with different origin
      return true;
    }
  }
  private setUserCancelled(dataPostback:GetPostbackFormDataResponse):void{
    this.userCancelled = dataPostback?.result === '-1' && dataPostback?.status === 'USER_CANCELLED';
  }

  private getPostbackData(): void {
    console.log('Fetching postback data');
    this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken'))
        .subscribe((dataPostback: GetPostbackFormDataResponse) => {
          this.postbackData = dataPostback;
          this.setUserCancelled(this.postbackData);
          this.result = this.postBackResultSuccessful(this.postbackData.result);
          if (this.postbackData.errorMessage) {
            this.errorMessage = this.postbackData.errorMessage;
          }
          this.loading = false;
          this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
        }, (err) => {
          this.setTimeoutForHtmlFormAndSubmit(this.postbackData);
        });
  }
}
